/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import useSWR from 'swr'
import axios from 'axios'
// import fetcher from './fetcher'
import useToken from './useToken'

export default function useAPI(
  endpoint,
  method,
  body = null,
  queryParams = null,
  options = {
    errorRetryInterval: 1000,
    errorRetryCount: 3,
  }
) {
  const { headers } = useToken()
  const fetcher = (url) =>
    axios({
      method,
      url,
      headers,
      data: body,
    }).then((res) => res.data)

  const pathedEndpoint = `${process.env.NEXT_PUBLIC_API_URL}${endpoint}`
  return useSWR(
    headers
      ? queryParams
        ? `${pathedEndpoint}?${queryParams
            .map((z) => `${z.key}=${z.value}`)
            .join('&')}`
        : pathedEndpoint
      : null,
    fetcher,
    options
  )
}
